import { useQuery, useQueryClient } from '@tanstack/react-query';
import { endpoints, getIDFromUrl, loadEtag, Url } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';

const POLL_INTERVAL_MS = 15_000;
const POLL_SCHEMA_ETAG_QUERY_KEY = 'poll-schema-etag';

type UsePollSchemaEtagOptions = {
  initialEtag: string | undefined;
};

export const usePollSchemaEtag = (
  schemaUrl: Url | undefined,
  options: UsePollSchemaEtagOptions
) => {
  const { initialEtag } = options;
  const queryClient = useQueryClient();

  const { data: polledData, isFetching: isCheckingForChanges } = useQuery({
    queryKey: [POLL_SCHEMA_ETAG_QUERY_KEY, schemaUrl],
    queryFn: () =>
      api
        .fullRequest(endpoints.schemas.getRaw(getIDFromUrl(schemaUrl!)))
        .then(loadEtag),
    enabled: schemaUrl !== undefined && initialEtag !== undefined,
    refetchInterval: POLL_INTERVAL_MS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    staleTime: 0,
  });

  const checkForChanges = () => {
    queryClient.invalidateQueries(['poll-schema-etag', schemaUrl]);
  };

  return {
    remoteSchema: polledData,
    checkForChanges,
    isCheckingForChanges,
  };
};
